import ManageSites from './ManageSites'

export default ManageSites;